import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Dispatch } from "react";
import { Microservices } from "../../../../app/AllowedMicroservices";
import { RootState } from "../../../../app/store";
import apiActionCreator, {
  HttpMethods,
} from "../../../../services/apiActionCreator";
import { FetchStatus } from "../../../common/enums";
import { IFulfillment } from '../common/interfaces';


interface IFulfillmentState {
  courseFulfillment: IFulfillment[],
  status: FetchStatus,
}
const initialState: IFulfillmentState = {
  courseFulfillment: [],
  status: FetchStatus.Idle,
};

export const dataSlice = createSlice({
  name: "reportLearningCoursesFulfillment",
  initialState,
  reducers: {
    fetching: (state) => {
      state.status = FetchStatus.Fetching;
    },
    fetched: (state, action: PayloadAction<IFulfillment[]>) => {
      state.courseFulfillment = action.payload;
      state.status = FetchStatus.Fetched;
    },
    error: (state) => {
      state.status = FetchStatus.Error;
    },
  },
});

export const { fetching, fetched, error } = dataSlice.actions;

export const fetchCoursesCompletion = (groupId?: string, companyId?: string) => (dispatch: Dispatch<object>) => {
  let url = '/courses/completionPerGroup';
  if(groupId){
    url = `${url}/${groupId}`;
  }
  if(companyId){
    url = `${url}?companyId=${companyId}`;
  }
  return dispatch(
    apiActionCreator({
      endpoint: url,
      types: {
        requestType: fetching,
        successTypes: [
          {
            actionOrCreator: fetched,
          },
        ],
        errorTypes: [
          {
            actionOrCreator: error,
          },
        ],
      },
      method: HttpMethods.GET,
      microservice: Microservices.LEARNING_SERVICE,
      authenticated: true,
    })
  );
};

export const selectCoursesFulfillments = (state: RootState) => state.reports.learning.courses.coursesFulfillments.courseFulfillment;
export const selectCoursesFulfillmentsFetching = (state: RootState) => state.reports.learning.courses.coursesFulfillments.status === FetchStatus.Fetching;

export default dataSlice.reducer;
